module.exports = __webpack_public_path__ + "img/ergonomic.441f89c3.png";